<div
  class="datatable-loader"
  *ngIf="service?.loading"
  [ngClass]="{ 'datatable-loader--with-records': service?.rows.length }"
>
  <mat-progress-bar mode="indeterminate" />
</div>
